import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import Customer from '@/App/Customer/Entity/Customer'
import type {
    CustomerSharedDataRawData,
    PageMeta,
} from '@/Shared/AutoGenerated/Main'

export default class CustomerSharedData {
    constructor(
        public readonly appName: string,
        public readonly authCustomer: Customer | null,
        public readonly currentRoute: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    static hydrate(rawData: CustomerSharedDataRawData): CustomerSharedData {
        return new CustomerSharedData(
            rawData.appName,
            Customer.hydrateSingleOrNull(rawData.authCustomer),
            rawData.currentRoute,
        )
    }

    getAuthCustomer(): Customer {
        if (!this.authCustomer) {
            throw new Error('Auth customer not found')
        }

        return this.authCustomer
    }

    getAuthLayoutProps() {
        return {
            appName: this.appName,
        }
    }

    getAppLayoutProps(pageMeta: PageMeta | null) {
        return {
            pageMeta: pageMeta,
            appName: this.appName,
            authCustomer: this.getAuthCustomer(),
            currentRoute: this.currentRoute,
        }
    }
}
